// extracted by mini-css-extract-plugin
export var discover = "Intro-module--discover--ZEt8V";
export var enterB2t = "Intro-module--enterB2t--cbvVL";
export var hidden = "Intro-module--hidden--5bl8v";
export var inner = "Intro-module--inner--V-fKX";
export var observer = "Intro-module--observer--DMJ7J";
export var title = "Intro-module--title--tizub";
export var word = "Intro-module--word--JrU-f";
export var wrapper = "Intro-module--wrapper--lX56s";